// extracted by mini-css-extract-plugin
module.exports = {"fixedClass":"BackDraw__fixedClass__3NyL9"};